import { pdfjs } from "react-pdf";


if (typeof window !== "undefined" && !pdfjs.GlobalWorkerOptions.workerSrc) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
}

export const isPdf = (file) =>
  file?.type === "application/pdf" ||
  /\.pdf$/i.test(file?.name || "");


const SCALE = 2;

export const pdfFileToImages = async (file) => {
  const buffer = await file.arrayBuffer();
  const doc = await pdfjs.getDocument({ data: buffer }).promise;
  const images = [];

  try {
    for (let pageNumber = 1; pageNumber <= doc.numPages; pageNumber += 1) {
      // eslint-disable-next-line no-await-in-loop
      const page = await doc.getPage(pageNumber);
      const viewport = page.getViewport({ scale: SCALE });

      const canvas = document.createElement("canvas");
      canvas.width = Math.floor(viewport.width);
      canvas.height = Math.floor(viewport.height);

      await page.render({
        canvasContext: canvas.getContext("2d"),
        viewport,
      }).promise;

      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/png")
      );
      if (!blob) continue;

      const base = (file.name || "invoice").replace(/\.pdf$/i, "");
      images.push(
        new File([blob], `${base}-page-${pageNumber}.png`, { type: "image/png" })
      );

      page.cleanup();
    }
  } finally {
    doc.destroy();
  }

  return images;
};


export const filesToScannableImages = async (files) => {
  const out = [];
  for (const file of files) {
    if (isPdf(file)) {
      const pages = await pdfFileToImages(file);
      out.push(...pages);
    } else {
      out.push(file);
    }
  }
  return out;
};
